module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-divider', [_vm._v(_vm._s(_vm.$T('房间分配')))]), _vm._v(" "), (_vm.totalRooms > 0) ? _c('p', {
    staticClass: "hint"
  }, [_vm._v("\n      " + _vm._s(_vm.$T('已分配')) + ": " + _vm._s(_vm.assignedRooms) + " / " + _vm._s(_vm.totalRooms) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.assignmentList,
      "border": "",
      "stripe": "",
      "size": "mini",
      "empty-text": _vm.$T('暂无数据')
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50",
      "label": _vm.$T('序号')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('预订酒店'),
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.hotel_title || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('房型'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.room_type_name || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('入住退房'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "cell-stack readonly-dates"
        }, [_c('span', [_vm._v(_vm._s(scope.row.checkin_date || '-'))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.checkout_date || '-'))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('人员'),
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "cell-stack member-cell"
        }, [_c('el-autocomplete', {
          staticClass: "inline-input",
          attrs: {
            "fetch-suggestions": _vm.queryMemberSearch(scope.$index, 'member1'),
            "placeholder": _vm.$T('人员1'),
            "clearable": ""
          },
          on: {
            "select": function($event) {
              return _vm.onMemberAutocompleteSelect(scope.row, $event, 'member1')
            },
            "input": function($event) {
              return _vm.onMember1Change(scope.row)
            }
          },
          model: {
            value: (scope.row.member1),
            callback: function($$v) {
              _vm.$set(scope.row, "member1", $$v)
            },
            expression: "scope.row.member1"
          }
        }), _vm._v(" "), (_vm.getRoomLimit(scope.row) >= 2) ? _c('el-autocomplete', {
          staticClass: "inline-input",
          attrs: {
            "fetch-suggestions": _vm.queryMemberSearch(scope.$index, 'member2'),
            "placeholder": _vm.$T('人员2'),
            "clearable": ""
          },
          on: {
            "select": function($event) {
              return _vm.onMemberAutocompleteSelect(scope.row, $event, 'member2')
            }
          },
          model: {
            value: (scope.row.member2),
            callback: function($$v) {
              _vm.$set(scope.row, "member2", $$v)
            },
            expression: "scope.row.member2"
          }
        }) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('价格'),
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(Number(scope.row.price || 0).toFixed(2)) + " USD")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_c('span', [_vm._v(_vm._s(_vm.$T('房间数')) + ": " + _vm._s(_vm.totalRooms))])]), _vm._v(" "), _c('div', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v(_vm._s(_vm.$T('保存')))])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-755ae89e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep3RoomMember.vue
// module id = 1521
// module chunks = 0